import axios from "axios";

// ─────────────────────────────────────────────────────────────────────────────
// Contract Workers — dedicated API client.
// Own base path (/api/contract-workers), own service file. Shares nothing with
// the staff / attendance / labour modules.
// ─────────────────────────────────────────────────────────────────────────────
const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";
const BASE = `${API_BASE_URL}/api/contract-workers`;

const withProject = (projectId) =>
  projectId ? { headers: { "x-project-id": projectId } } : {};

const multipart = (projectId) => ({
  headers: {
    "Content-Type": "multipart/form-data",
    ...(projectId ? { "x-project-id": projectId } : {}),
  },
});

// ── Projects (local dropdown source) ──
export const cwListProjects = () => axios.get(`${BASE}/projects`);

// ── Workers ──
export const cwListWorkers = (params = {}, projectId) =>
  axios.get(BASE, { params, ...withProject(projectId) });

export const cwCreateWorker = (formData, projectId) =>
  axios.post(BASE, formData, multipart(projectId));

export const cwGetWorkerById = (id) => axios.get(`${BASE}/${id}`);

export const cwUpdateWorker = (id, formData) =>
  axios.patch(`${BASE}/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const cwSetWorkerStatus = (id, status) =>
  axios.post(`${BASE}/${id}/status`, { status });

export const cwSwitchWorkerProject = (id, projectId) =>
  axios.post(`${BASE}/${id}/project`, { projectId });

// ── Attendance ──
export const cwGetProjectList = (projectId, date) =>
  axios.get(`${BASE}/project/${projectId}/list`, {
    params: date ? { date } : {},
  });

export const cwMarkAttendance = (formData, projectId) =>
  axios.post(`${BASE}/attendance`, formData, multipart(projectId));

// Turn a worker's already-recorded day into a half day (or back to full).
export const cwSetWorkerOut = (projectId, workerId, date, status = "half") =>
  axios.post(
    `${BASE}/attendance/out`,
    { projectId, workerId, date, status },
    withProject(projectId),
  );

// ── Roster + calendar ──
export const cwGetRoster = (params = {}, projectId) =>
  axios.get(`${BASE}/roster`, { params, ...withProject(projectId) });

export const cwGetDailyRoster = (projectId, date) =>
  axios.get(`${BASE}/daily-roster`, {
    params: { projectId, ...(date ? { date } : {}) },
    ...withProject(projectId),
  });

export const cwGetWorkerCalendar = (id, month) =>
  axios.get(`${BASE}/${id}/calendar`, { params: month ? { month } : {} });

// Super-admin: force-mark workers for any date (no photo). entries:
// [{ workerId, status: "full" | "half" | "leave" }]
export const cwForceMark = (projectId, date, entries) =>
  axios.post(
    `${BASE}/attendance/force`,
    { projectId, date, entries },
    withProject(projectId),
  );
